
import React from "react";

import { Routes, Route, BrowserRouter } from "react-router-dom"
import Home from './Pages/Home';
import Aboutus from './Pages/Aboutus';
import Career from './Pages/Career';
import Media from './Pages/Media';
import Contactus from './Pages/Contactus';
import FinancialServices from './Pages/FinancialServices';
import OurServices from './Pages/OurServices';
import TechnologyServices from './Pages/TechnologyServices';
import AdvisoryServices from './Pages/AdvisoryServices';
import Termsofuse from "./Pages/Termsofuse";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import ParticularsTable from "./Pages/Investors";
import FinancialDocuments from "./Pages/FinancialAndReport";
import BoardDetails from "./Pages/Share_Governance_Service";
import DPRH from "./Pages/DPRH";
import MaterialContracts from "./Pages/MaterialContracts";
import GroupCompany from "./Pages/GroupCompany";
import MaterialDocuments from "./Pages/MaterialDocument";
import AddendumToDRHP from "./Pages/AddendumToDRHP";
import OfferDocuments from "./Pages/OfferDocuments";
import Advertisement from "./Pages/Advertisement";
import ShareHolderPattern from "./Pages/ShareHolderPattern";
import IndustrySearchReport from "./Pages/IndustrySearchReport";
import Regulation46 from "./Pages/Regulation46";
import Regulation30 from "./Pages/Regulation30";
import CorporateAnnouncements from "./Pages/CorporateAnnouncements";
// import HomePage from "./Pages/HomePage";




function App() {
    return (

 
     
 <BrowserRouter>

   <Routes>
    {/* <Route   path='/' element={<HomePage />} /> */}
    <Route  path='/' element={<Home />} />
    <Route  path='/Aboutus' element={<Aboutus />} />
    <Route  path='/Investors' element={<ParticularsTable />} />
    <Route  path='/FinancialServices' element={<FinancialServices />} />
    <Route  path='/OurServices' element={<OurServices />} />
    <Route  path='/FinancialAndReports' element={<FinancialDocuments />} />
    <Route  path='/share-governance-investor-services' element={<BoardDetails />} />
    <Route  path='/shareholder-pattern' element={<ShareHolderPattern />} />
    <Route  path='/shareholding-pattern' element={<ShareHolderPattern />} />
    <Route  path='/industry-search-report' element={<IndustrySearchReport />} />
    <Route  path='/industry-report' element={<IndustrySearchReport />} />
    <Route  path='/Group-Entities' element={<GroupCompany />} />
    <Route  path='/drhp' element={<DPRH />} />
    <Route  path='/addendum-to-drhp' element={<AddendumToDRHP />} />
     <Route  path='/MaterialContracts' element={<MaterialContracts />} />
     <Route  path='/MaterialDocuments' element={<MaterialDocuments/>} />
     <Route  path='/offer-documents' element={<OfferDocuments />} />
     <Route  path='/advertisement' element={<Advertisement />} />
     <Route  path='/regulation-46-lodr' element={<Regulation46 />} />
     <Route  path='/regulation-30' element={<Regulation30 />} />
     <Route  path='/corporate-announcements' element={<CorporateAnnouncements />} />
    
    <Route  path='/TechnologyServices' element={<TechnologyServices />} />
    <Route  path='/AdvisoryServices' element={<AdvisoryServices />} />
     <Route  path='/Career' element={<Career />} />
     <Route  path='/Media' element={<Media />} />
     <Route  path='/Contactus' element={<Contactus />} />
     <Route  path='/Termsofuse' element={<Termsofuse />} />
     <Route  path='/PrivacyPolicy' element={<PrivacyPolicy />} />


   </Routes>

</BrowserRouter>

    
  );
}

export default App;
